import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
/**
 * React functional component for a modal dialog with redirection capability.
 * @component
 * @param redirectToPath - The path to redirect to when the user confirms the modal.
 * @param open - Controls whether the modal is open or closed.
 * @param onCancel - Callback function to handle the modal cancellation event.
 * @param children - Content to be displayed within the modal.
 * @param restProps - Additional props to be passed to the Ant Design Modal component.
 *
 * @returns The rendered RedirectModal component.
 */ const RedirectModal = ({ redirectToPath, open, onCancel, children, ...restProps })=>{
    const navigate = useNavigate();
    const redirect = ()=>{
        navigate({
            pathname: redirectToPath
        });
    };
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        onCancel: onCancel,
        onOk: redirect,
        centered: true,
        destroyOnClose: true,
        ...restProps,
        children: children
    });
};
export { RedirectModal };
